"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateGasMargin = exports.isTradeBetter = exports.isZero = void 0;
const constants_1 = require("../constants");
const isZero = (hexNumberString) => {
    return /^0x0*$/.test(hexNumberString);
};
exports.isZero = isZero;
const isTradeBetter = (tradeA, tradeB, minimumDelta = constants_1.ZERO_PERCENT) => {
    if (tradeA && !tradeB)
        return false;
    if (tradeB && !tradeA)
        return true;
    if (!tradeA || !tradeB)
        return undefined;
    if (tradeA.tradeType !== tradeB.tradeType ||
        !tradeA.inputAmount.currency.equals(tradeB.inputAmount.currency) ||
        !tradeA.outputAmount.currency.equals(tradeB.outputAmount.currency)) {
        throw new Error("Comparing incomparable trades");
    }
    if (minimumDelta.equalTo(constants_1.ZERO_PERCENT)) {
        return tradeA.executionPrice.lessThan(tradeB.executionPrice);
    }
    else {
        return tradeA.executionPrice.asFraction
            .multiply(minimumDelta.add(constants_1.ONE_HUNDRED_PERCENT))
            .lessThan(tradeB.executionPrice);
    }
};
exports.isTradeBetter = isTradeBetter;
const calculateGasMargin = (value) => {
    return value.mul(120).div(100);
};
exports.calculateGasMargin = calculateGasMargin;
